import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'black-grade-selection',
    templateUrl: './grade-selection.component.html',
    styleUrls: ['./grade-selection.component.css'],
    standalone: false
})
export class GradeSelectionComponent implements OnInit {

  grade_list = [
    { text: '1', selected: false },
    { text: '2', selected: false },
    { text: '3', selected: false },
    { text: '4', selected: false },
    { text: '5', selected: false },
    { text: '6', selected: false },
  ];

  constructor() {}

  ngOnInit(): void {}

  changeState(index: number) {
    this.grade_list[index].selected = !this.grade_list[index].selected;
  }
}
